import { v4 } from 'uuid';

export default function genGuid() {
    return v4();
}
